module.exports = __webpack_public_path__ + "assets/img/familyCrest-777236c1.png";